// © Microsoft Corporation. All rights reserved.
import { environment, ExperienceTypes, AppType, registerCommandMessageHandler, WebWorkerMessageId, webWorkerCache } from "../wwCommon";
import { get } from "lodash-es";
import { getExperienceTypeConfig } from "../wwResolver";
import { oneServiceHeaders } from "./OneServiceConstants";
import { tryReformatGuid } from "./Common";
/** The aadToken QS key */
export const aadTokenQsKey = "stn";
/** The aadToken QS value */
export const aadTokenQsVal = "aad";
let aadToken;
/** Registers command handler for Aad Token message */
export function registerOneServiceTokenListener() {
    registerCommandMessageHandler(WebWorkerMessageId.AuthToken, (token) => {
        aadToken = token;
        webWorkerCache.set(WebWorkerMessageId.AuthToken, token);
    });
}
/**
 * Gets common headers used in service requests to OneService
 * @param useEnterpriseHeaders true if enterprise headers should be forced for the request
 * @returns The common headers to use on OneService requests.
 */
export function getOneServiceHeaders(useEnterpriseHeaders = shouldMakeEnterpriseRequest()) {
    const headers = {};
    if (aadToken && useEnterpriseHeaders) {
        headers[oneServiceHeaders.authorization] = `Bearer ${aadToken}`;
    }
    return headers;
}
/**
 * Returns true if enterprise request should be made for the river call only
 *
 * @export
 * @returns {boolean}
 */
export function shouldMakeEnterpriseRequest() {
    return !!getEntryPointConfigSetting("properties.useEnterpriseCompliance");
}
/**
 * Returns true if enterprise domain should be used for the river call only
 *
 * @export
 * @returns {boolean}
 */
export function shouldUseEnterpriseDomain() {
    if (!shouldMakeEnterpriseRequest()) {
        return false;
    }
    return !!getEntryPointConfigSetting("properties.useEnterpriseDomain");
}
/**
 * Gets headers used in service requests to OneService /feed and /feed/me endpoints
 * @param useEnterpriseHeaders true if enterprise headers should be forced for the request
 * @returns The headers to use on the OneService request.
 */
export function getOneServiceFeedCallHeaders(useEnterpriseHeaders) {
    const headers = getOneServiceHeaders(useEnterpriseHeaders);
    const activityId = environment.activityId;
    if (environment.sendFeedCallActivityIdInHeader && activityId) {
        headers[oneServiceHeaders.activityId] = tryReformatGuid(activityId);
    }
    return headers;
}
/** Gets the entry point config */
function getEntryPointConfigSetting(path) {
    const entryPointConfigName = environment.apptype === AppType.EdgeChromium ? ExperienceTypes.EntryPointEdgeNext : ExperienceTypes.EntryPoint;
    const entryPointConfig = getExperienceTypeConfig(entryPointConfigName);
    if (!entryPointConfig) {
        return;
    }
    return get(entryPointConfig, path);
}
//# sourceMappingURL=OneServiceRequest.js.map